import { combineSlices } from '@reduxjs/toolkit';
import FJLoadingModalSlice from './FJLoadingModalSlice.ts';
import FJGoogleDriveSlice from './FJGoogleDriveModalSlice.ts';
import FJCutVideoSlice from './FJCutVideoSlice.ts';
import FJAddSocialSlice from './FJAddSocialSlice.ts';
import FJPublishHistorySlice from './FJPublishHistorySlice.ts';

const combinedSlices = combineSlices({
    loading: FJLoadingModalSlice.reducer,
    googleDrive: FJGoogleDriveSlice.reducer,
    cut: FJCutVideoSlice.reducer,
    bindSocial: FJAddSocialSlice.reducer,
    publishHistory: FJPublishHistorySlice.reducer,
});

export default combinedSlices;
